import React from 'react';
import cx from 'classnames';
import { UncontrolledTooltip } from 'reactstrap';
import { useId } from 'js/hooks/useId';

const COLUMN_TYPE_LABELS = {
  question: 'Question',
  questionSet: 'Question Set',
};

const ScorecardHeaderCell = ({ columnType, text }) => {
  const targetId = useId();
  const typeLabel = COLUMN_TYPE_LABELS[columnType] ?? 'Question';

  return (
    <div
      id={targetId}
      className={cx({
        'squad-scorecard-question': columnType !== 'questionSet',
        'squad-scorecard-question-set': columnType === 'questionSet',
      })}
    >
      <span className="squad-scorecard-column-name">{text}</span>
      <UncontrolledTooltip
        placement="top"
        target={targetId}
        container="body"
        fade={false}
        delay={{ show: 300, hide: 100 }}
        popperClassName="squad-scorecard-header-tooltip-popover"
        boundariesElement="window"
      >
        <div className="squad-scorecard-header-tooltip">
          <div
            className={cx('squad-scorecard-header-tooltip-label', {
              'squad-scorecard-header-tooltip-label--question-set':
                columnType === 'questionSet',
            })}
          >
            {typeLabel}
          </div>
          <div className="squad-scorecard-header-tooltip-text">{text}</div>
        </div>
      </UncontrolledTooltip>
    </div>
  );
};

export default ScorecardHeaderCell;
